const ChevronDownFull = () => {
  return (
    <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.5" d="M6 8L6 0L0 4.00155L6 8Z" fill="#225AEA" />
    </svg>
  )
}

export default ChevronDownFull
